module.exports = __webpack_public_path__ + "static/media/Watch.42d7ac6f.jpg";